<div class="container">
  <div class="text-center">
    <h5 class="display-5 mt-3 mb-4">Admin Panel</h5>
  </div>
</div>

<div class="container mb-5">
  <div class="row">
    <div class="col">
      <button type="button" class="btn btn-info" data-toggle="modal" data-target="#changePasswordModal">
        Change password
      </button>
    </div>
    <div class="col">
      <button type="button" class="btn btn-dark logout-btn" (click)="onLogout()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock mb-1" viewBox="0 0 16 16">
          <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"/>
        </svg>
        Logout
      </button>
    </div>
  </div>

  <hr>

  <!-- Terms & Conditons -->
  <div class="card-section mt-3 p-3">
    <h4 class="pb-3">Terms & Conditions:</h4>
    <div class="input-group mb-3">
      <textarea class="form-control form-control-lg" rows="8" [(ngModel)]="termsAndConditions"></textarea>
    </div>

    <button type="button" class="btn btn-primary update-btn" (click)="onUpdate()">Update</button>
  </div>

  <!-- Privacy Policy -->
  <div class="card-section mt-5 p-3">
    <h4 class="pb-3">Privacy Policy:</h4>
    <div class="input-group mb-3">
      <textarea class="form-control form-control-lg" rows="8" [(ngModel)]="privacyPolicy"></textarea>
    </div>

    <button type="button" class="btn btn-primary update-btn" (click)="onUpdate()">Update</button>
  </div>

  <!-- Cancellation Policy -->
  <div class="card-section mt-5 p-3">
    <h4 class="pb-3">Cancellation Policy:</h4>
    <div class="input-group mb-3">
      <textarea class="form-control form-control-lg" rows="8" [(ngModel)]="cancellationPolicy"></textarea>
    </div>

    <button type="button" class="btn btn-primary update-btn" (click)="onUpdate()">Update</button>
  </div>
</div>


<!-- Change Password Modal -->
<div class="modal fade" id="changePasswordModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Change Password</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="input-group input-group-lg mb-3">
          <input type="password" class="form-control" placeholder="Enter old password*" [(ngModel)]="oldPassword">
        </div>
        <div class="input-group input-group-lg mb-3">
          <input type="password" class="form-control" placeholder="Enter new password*" [(ngModel)]="newPassword">
        </div>
        <div class="input-group input-group-lg mb-3">
          <input type="password" class="form-control" placeholder="Confirm new password*" [(ngModel)]="confirmPassword">
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="incorrectOldPasswordError===true">
          Incorrect Old Password!
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="confirmPasswordError===true">
          Confirm Password doesn't match!
        </div>
        <div class="alert alert-success" role="alert" *ngIf="passwordChangedAlert===true">
          Password Changed Successfully!
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-outline-dark" (click)="onChangePassword()">Confirm</button>
        <button type="button" class="btn btn-sm btn-outline-danger" data-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>
